import React, { useState } from "react"
import { Helmet } from "react-helmet"

import Banner from "../components/Banner"
import Layout from "../components/Layout"
import { CouncilCard } from "../components/CouncilCard"
import { ourTeamData } from "../data/our-team.js"
import {
  gridContainer,
  headerContainer,
  dropDown,
} from "../styles/ourteam.module.css"
import Select from "react-select"
const OurTeamPage = () => {
  const options = [
    { value: "2026", label: "2026" },
    { value: "2025", label: "2025" },
    { value: "2024", label: "2024" },
    { value: "2023", label: "2023" },
    { value: "2022", label: "2022" },
    { value: "2021", label: "2021" },
  ]
  const [year, setYear] = useState("2026")
  const handleYearChange = e => {
    setYear(e.value)
  }
  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <title>PICT ACM Student Chapter | Our Team</title>
        <meta
          name="description"
          content="PICT ACM Student Chapter(PASC), a student chapter organization subsidiary of the Association for Computing Machinery(ACM), consists of highly motivated students, ready to learn and help each other bring the best out of them. PASC began in 2011, with the perspective of fostering technical and non-technical qualities in an individual and helping them to shape their future."
        />
      </Helmet>
      <Banner
        title="Our Team"
        text={`We are an Award-Winning team. Our team consists of technically sound members that transform novel ideas into real-life experiences. We believe in a pragmatic approach and commit to quality and end-to-end processes. With a high level of confidence and integrity, we believe in contributing to the real-world web production environment.`}
        image="team1.png"
      />
      <div className={`${headerContainer}`}>
        <p className="heading">Our Team</p>
        <div className={`${dropDown}`}>
          <Select
            options={options}
            onChange={handleYearChange}
            defaultValue={options[0]}
          />
        </div>
      </div>
      <div className={`${gridContainer} px-16 m-auto`}>
        <CouncilCard details={ourTeamData[0]} />
      </div>
      <div className={`${gridContainer} px-16 m-auto`}>
        {ourTeamData.map((member, i) =>
          parseInt(member.year) === parseInt(year) ? (
            <CouncilCard details={member} key={i} />
          ) : null
        )}
      </div>
    </Layout>
  )
}

export default OurTeamPage
